module.exports = __webpack_public_path__ + "assets/img/youtube.75449833.webp";